// Required dependencies that need to be bound to the window.
window.jQuery = window.$ = require('jquery');
window.Bootstrap = require('bootstrap');
window.Select2 = require('select2');
window.Skycons = require('./assets/js/skycons/skycons.js');
window.Moment = require('moment');
window._ = require('lodash');

// Configure the font path for canvas gauge
window.CANV_GAUGE_FONTS_PATH = '/static/fonts';

// Required dependencies that do not need to be bound to the window.
require('jquery-csv');
require('datatables.net');
require('datatables.net-bs');
require('datatables.net-responsive');
require('range2dslider');
require('bootstrap-daterangepicker');
require('bootstrap-touchspin');
require('./assets/js/nestedSortable.js')
require('./assets/js/slimscroll/jquery.slimscroll.js');
require('./assets/js/tip/jquery.tooltipster.min.js');
require('./assets/js/scriptbreaker-multiple-accordion-1.js');
require('./assets/js/jquery.sticky.js');
require('./assets/js/loader/loader.js');
require('./assets/js/bootstrap-toggle.js');
require('./assets/js/number-progress-bar/jquery.velocity.min.js');
require('./assets/js/number-progress-bar/number-pb.js');

import Vue from 'vue'
import Router from './routes'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if(process.env.NODE_ENV == 'production') {
	Raven
	    .config('https://d7c7c6cc128a4b6fb0a0990924090d0b@bugs.codium.com.au/23')
	    .addPlugin(RavenVue, Vue)
	    .install();
}

const App = Vue.extend(require('./app'));

import registerVueComponents from './components/index'
import registerVueDirectives from './directives/index'

registerVueComponents(Vue);
registerVueDirectives(Vue);

import './interceptors/jwt'
import './interceptors/unauthorized'

Router.start(App, 'app');

export default Router.app;



// WEBPACK FOOTER //
// ./src/main.js